import ActionTypeContrato from "../ActionTypeContrato";

export default class FinalizarComando extends ActionTypeContrato {
    ejecutar(estado, nuevoEstado) {
        nuevoEstado.flag.procesandoComando = false;
        return nuevoEstado;
    }
}
